import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-26e2eac7")
const _hoisted_1 = {
  ref: "animateRef",
  class: "flex items-center px-[16px] text-base opacity-0"
}
const _hoisted_2 = { class: "flex-auto" }
const _hoisted_3 = { class: "token-name" }
const _hoisted_4 = { class: "token-symbol" }
const _hoisted_5 = { class: "token-amount flex flex-col items-end text-right font-medium" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" < 0.0001 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("0")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalLoadingNumber = _resolveComponent("BalLoadingNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BalAsset, {
      address: $props.token.address,
      iconURI: $props.token.logoURI,
      size: 36,
      class: "mr-[12px]"
    }, null, 8, ["address", "iconURI"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.token.name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.token.symbol), 1)
    ]),
    _createElementVNode("span", _hoisted_5, [
      ($props.balanceLoading)
        ? (_openBlock(), _createBlock(_component_BalLoadingNumber, {
            key: 0,
            type: "token"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($setup.balance > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($setup.balance >= 0.0001)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString($setup.fNum2($setup.balance, $setup.FNumFormats.token)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_6
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_7
                ], 64))
          ], 64))
    ])
  ], 512))
}